const logotext = "KUHLMANN";
const meta = {
    title: "Florian Kuhlmann",
    description: "Ich bin Product Owner aus Bielefeld.",
};

const introdata = {
    title: "Florian Kuhlmann – Product Owner, Technik Enthusiast und Hobbybrauer mit Leidenschaft.",
    animated: {
        first: "Product Owner",
        second: "Freizeit Developer",
        third: "Hobbybrauer",
    },
    description: "Ich manage digitale Produkte, die nicht nur funktionieren, sondern begeistern. Von IoT-Plattformen bis zu Industrie 4.0-Lösungen – ich bringe Projekte mit Struktur, Teamwork und dem Blick fürs Detail ins Ziel. Und Meilensteine feiern? Das geht bei mir am besten mit einem selbstgebrauten Bier.",
    your_img_url: '/images/me_1.jpg',
};

const dataabout = {
    title: "Wo Technik, Teamgeist und Leidenschaft zusammentreffen",
    aboutme: "Seit über 10 Jahren setze ich als Product Owner digitale Projekte um, die Mehrwert schaffen und nachhaltig wirken. Ob IoT-Plattform, AI für Kanalreinigungsfahrzeuge oder Roboterarme mit ROS – ich übersetze komplexe Anforderungen in klare, greifbare Lösungen.",
    values: "Auf einem landwirtschaftlichen Betrieb groß geworden, habe ich früh gelernt, wie wichtig harte Arbeit und Durchhaltevermögen sind. Diese Werte begleiten mich in allen Bereichen meines Lebens.",
    why: "Weil beides Präzision und Leidenschaft erfordert – und ich beides liebe. ",
};

const worktimeline = [
    {
        jobtitle: "Product Owner Digital Products Professional",
        where: "Top Secret",
        date: "2017 - Heute",
    },
    {
        jobtitle: "Forschungsingenieur für maschinelles Lernen in der Industrie",
        where: "Institut für Industrielle Informationstechnik",
        date: "2016 - 2017",
    },
    {
        jobtitle: "Fachinformatiker für Systemintegration",
        where: "Hubert Stüken GmBH & Co. KG",
        date: "2007 - 2011",
    },
];

const skills = [
    {
        name: "Produktstrategie",
        value: 95,
        description: "Entwickle Roadmaps, die technische Machbarkeit und Nutzerbedürfnisse perfekt verbinden.",
        category: "Product Owner Skills"
    },
    {
        name: "Stakeholder-Management",
        value: 80,
        description: "Klare Kommunikation und transparente Entscheidungen – für ein gemeinsames Ziel.",
        category: "Product Owner Skills"
    },
    {
        name: "Agile Methoden",
        value: 85,
        description: "Scrum, Kanban oder SAFe – immer passend zum Projekt. Methoden: Story Mapping, Backlog Refinement",
        category: "Product Owner Skills"
    },
    {
        name: "Change Management",
        value: 95,
        description: "Teams sicher durch Veränderungen führen und dabei die Motivation hochhalten.",
        category: "Product Owner Skills"
    },
    {
        name: "Scrum Master",
        value: 65,
        description: "Hindernisse aus dem Weg räumen und Prozesse optimieren.",
        category: "Product Owner Skills"
    },
    {
        name: "Datengetriebene Entscheidungen",
        value: 75,
        description: "Mit Datenanalysen fundierte Entscheidungen treffen und Produkte verbessern.",
        category: "Product Owner Skills"
    },
    {
        name: "Java",
        value: 75,
        category: "Technologische Expertise"
    },
    {
        name: "Python",
        value: 70,
        category: "Technologische Expertise"
    },
    {
        name: "C",
        value: 70,
        category: "Technologische Expertise"
    },
    {
        name: "C++",
        value: 85,
        category: "Technologische Expertise"
    },
    {
        name: "React Native",
        value: 85,
        category: "Technologische Expertise"
    },
    {
        name: "Docker",
        value: 75,
        category: "Technologische Expertise"
    },
    {
        name: "ROS",
        value: 65,
        category: "Technologische Expertise"
    },
    {
        name: "Cassandra DB",
        value: 80,
        category: "Technologische Expertise"
    },
    {
        name: "MongoDB",
        value: 85,
        category: "Technologische Expertise"
    },
    {
        name: "Adminstration & IT-Sicherheit",
        value: 85,
        category: "Technologische Expertise"
    },
    {
        name: "Leadership",
        value: 95,
        description: "Teams motivieren und stärken, um gemeinsam Bestleistungen zu erzielen.",
        category: "Soft Skills"
    },
    {
        name: "Kommunikation",
        value: 90,
        description: "Komplexe Themen verständlich und prägnant auf den Punkt bringen.",
        category: "Soft Skills"
    },
    {
        name: "Problemlösung",
        value: 85,
        description: "Herausforderungen analytisch und strukturiert angehen.",
        category: "Soft Skills"
    },
];

const services = [
    {
        title: "Produktstrategie & digitale Transformation",
        description: "Entwicklung von klaren Roadmaps, die Business-Ziele, Nutzerbedürfnisse und technische Anforderungen vereinen.",
    },
    {
        title: "Stakeholder-Management & Anforderungsanalyse",
        description: "Vermittlung zwischen Abteilungen, um klare und priorisierte Anforderungen sicherzustellen.",
    },
    {
        title: "Agile Coaching & Prozessoptimierung",
        description: "Einführung und Optimierung agiler Methoden wie Scrum und Kanban für effiziente Teams.",
    },
    {
        title: "IoT-Beratung & Systemintegration",
        description: "Entwicklung vernetzter Plattformen und sicherer, skalierbarer Systemlösungen.",
    },
    {
        title: "Bierbrau-Workshops",
        description: "Vermittlung von Braukunst mit Fokus auf Geschmack und Prozess.",
    },
    {
        title: "Karriere-Coaching für Product Owner",
        description: "Unterstützung angehender Product Owner bei Roadmap-Entwicklung und agiler Führung.",
    },
];

const dataportfolio = [
    {
        img: '/images/plattform.webp',
        description: "Internationale IoT-Plattform – Für intelligentere und effizientere Reinigungsprozesse.",
        //link: "https://example.com/projekt1",
    },
    {
        img: '/images/bier.webp',
        description: "Kühl, klar, Kuhlmanns Altdeutsches – das Helle mit Charakter.",
        //link: "https://example.com/projekt2",
    },
    {
        img: '/images/kanal.webp',
        description: "AI für Kanalreinigungsfahrzeuge – Automatisierung von Konfigurationsprozessen.",
        //link: "https://example.com/projekt3",
    },
    {
        img: '/images/challengeMe.webp',
        description: "ChallengeMe – Tägliche Herausforderungen, die dich wachsen lassen.",
        //link: "https://example.com/projekt4",
    },
];

const contactConfig = {
    YOUR_EMAIL: "kuhlmann-florian@web.de",
    YOUR_FONE: "+49 151 404444243",
    description: "Kontaktieren Sie mich für weitere Informationen oder Projekte.",
    YOUR_SERVICE_ID: "service_gy2cydq",
    YOUR_TEMPLATE_ID: "template_r1i0x4p",
    YOUR_USER_ID: "fdnQO-sSevBQ5NUai",
};

const socialprofils = {
    github: "https://github.com/fuelmerfeife",
    instagram: "https://instagram.com/fuelmerfeife",
    twitter: "https://X.com/fuelmerfeife",
};

export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};